import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ContractComponent } from './contract.component';
import { ContractListComponent } from './contract-list/contract-list.component';
import {ContractImportComponent} from './contract-import/contract-import.component';

const routes: Routes = [
  {
    path:"",
    component: ContractComponent,
    children:[
      {
        path: 'contractlist',
       component: ContractListComponent,
        data: {
          description:'Quản lý hợp đồng',
        }
      },
      {
        path: 'import',
        component: ContractImportComponent,
        data: {
          description:'Import hợp đồng',
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class ContractRoutingModule { }
